import * as React from 'react';

import styles from './NotFoundPage.scss';
import LinkButton from '../Button/LinkButton';
import LogoRow from '../../containers/LogoRow/LogoRow';
import { NotFoundPageLocale } from './notFoundPage.locale';

interface NotFoundProps {
  leftNumbers: string;
  rightNumbers: string;
  leftFinished: boolean;
  rightFinished: boolean;
  locale: NotFoundPageLocale;
}

const NotFound: React.SFC<NotFoundProps> = ({
  leftNumbers,
  rightNumbers,
  leftFinished,
  rightFinished,
  locale,
}) => (
  <header className={styles.wrapper}>
    <div className="container">
      <LogoRow />
    </div>
    <div className="d-flex flex-column align-items-center justify-content-center py-8">
      <div className={styles.numbers}>
        <div>{leftNumbers}</div>
        {!leftFinished &&
          !rightFinished && (
            <h1 className={styles.title} data-text="000">
              000
            </h1>
          )}
        {leftFinished &&
          !rightFinished && (
            <h1 className={`${styles.title} ${styles.shake}`} data-text="400">
              400
            </h1>
          )}
        {leftFinished &&
          rightFinished && (
            <h1 className={`${styles.title} ${styles.shake}`} data-text="404">
              404
            </h1>
          )}
        <div>{rightNumbers}</div>
      </div>
      <div className={styles.subtitle}>{locale.subtitle}</div>
      <LinkButton to={locale.button.href}>{locale.button.text}</LinkButton>
    </div>
  </header>
);

export default NotFound;



// WEBPACK FOOTER //
// /www/client/src/components/NotFoundPage/NotFoundPage.tsx